export function clamp01(value: number): number {
  return Math.min(1, Math.max(0, value))
}

export function remapProgress(
  progress: number,
  start: number,
  end: number,
): number {
  if (end === start) {
    return progress >= end ? 1 : 0
  }
  const rawRatio = (progress - start) / (end - start)
  const roundedRatio = Math.round(rawRatio * 1e9) / 1e9
  return clamp01(roundedRatio)
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t
}

export function easeOutBack(t: number): number {
  const overshoot = 1.70158
  const c3 = overshoot + 1
  const shifted = t - 1
  return 1 + c3 * shifted ** 3 + overshoot * shifted ** 2
}

export function smoothstep01(t: number): number {
  const clamped = clamp01(t)
  return clamped * clamped * (3 - 2 * clamped)
}
